'use client'

import { useRouter } from 'next/navigation'
import { matchesPath } from '@/lib/standings-logos'

function shiftDay(day: string, delta: number): string {
  const [y, m, d] = day.split('-').map(Number)
  const dt = new Date(Date.UTC(y, m - 1, d))
  dt.setUTCDate(dt.getUTCDate() + delta)
  return dt.toISOString().slice(0, 10)
}

function todayIstanbul(): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Istanbul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date())
}

export default function LivescoreDateNav({
  lig,
  day,
}: {
  lig?: string | null
  /** Seçili gün (YYYY-MM-DD), yoksa bugün */
  day?: string | null
}) {
  const router = useRouter()
  const today = todayIstanbul()
  const activeDay = day && /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : today
  const isToday = activeDay === today

  const go = (next: string | null) => {
    router.push(matchesPath(lig, next && next !== today ? next : null))
  }

  return (
    <div className="grid w-full grid-cols-[2.25rem_minmax(0,1fr)_auto_2.25rem] items-center gap-2 sm:flex sm:w-auto sm:flex-wrap">
      <button
        type="button"
        onClick={() => go(shiftDay(activeDay, -1))}
        className="flex size-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-sm font-bold text-gray-700 hover:border-red-200 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
        aria-label="Önceki gün"
      >
        ‹
      </button>

      <label className="relative flex min-w-0 items-center">
        <span className="sr-only">Tarih seç</span>
        <input
          type="date"
          value={activeDay}
          onChange={(e) => {
            const v = e.target.value
            if (!v) return
            go(v)
          }}
          className="w-full min-w-0 rounded-lg border border-gray-200 bg-white px-2 py-1.5 text-sm font-semibold tabular-nums text-gray-800 hover:border-red-200 focus:border-[#D92E2E] focus:outline-none dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 sm:px-2.5"
        />
      </label>

      <button
        type="button"
        onClick={() => go(null)}
        className={
          isToday
            ? 'rounded-lg bg-[#D92E2E] px-2.5 py-1.5 text-sm font-bold text-white sm:px-3'
            : 'rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-700 hover:border-red-200 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 sm:px-3'
        }
      >
        Bugün
      </button>

      <button
        type="button"
        onClick={() => go(shiftDay(activeDay, 1))}
        className="flex size-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-sm font-bold text-gray-700 hover:border-red-200 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
        aria-label="Sonraki gün"
      >
        ›
      </button>
    </div>
  )
}
